import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Confrontation } from '../../shared';

import { IssueMainComponent } from './components/issue-main.component';
import { IssueCreaterComponent } from './';
import { AllIssueComponent } from './';

import { CanActivate } from '@angular/router';
import { IssuesService } from './services/issues.service';
import { AuthGuardService } from '../../shared';

// Route Configuration
export const issuesRoutes: Routes = [
    {
        path: 'issues',
        component: IssueMainComponent,
        children: [
            {
                path: 'all',
                component: AllIssueComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'all/issue',
                component: IssueCreaterComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'all/issue/:issueId',
                component: IssueCreaterComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'all/issue/:isView/:issueId',
                component: IssueCreaterComponent,
                canActivate: [AuthGuardService]
            }
        ]
    }
];

export const issuesRoutingProviders: any[] = [
    AuthGuardService,
    IssuesService
];


// WEBPACK FOOTER //
// ./src/app/modules/issues/issues.routes.ts